export function getCountries(lang = 'en') {
  const A = 65;
  const Z = 90;
  const countryName = new Intl.DisplayNames([lang], { type: 'region' });
  const countries: Record<string, string> = {};
  for (let i = A; i <= Z; ++i) {
    for (let j = A; j <= Z; ++j) {
      const code = String.fromCharCode(i) + String.fromCharCode(j);
      const name = countryName.of(code);
      if (code !== name) {
        countries[code] = name!;
      }
    }
  }

  const countriesArray = [countries].flatMap((countryObj) =>
    Object.entries(countryObj).map(([code, name]) => ({
      code,
      name,
    })),
  );

  return countriesArray.sort((a, b) => (a.code === 'US' ? -1 : b.code === 'US' ? 1 : 0));
}
